import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import basicStyle from '../../config/basicStyle';
import ContentHolder from '../../components/utility/contentHolder';
import API_URL from './../../constants/server';
import axios from 'axios';
import appActions from '../../redux/app/actions';
const { appSelected, searchTermUpdated } = appActions;
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import SwipeableInkTabBar from 'rc-tabs/lib/SwipeableInkTabBar';
import 'rc-tabs/assets/index.css';
import { bindActionCreators } from 'redux'
import { HomeWrapper } from './style';
import IsoWidgetsWrapper from './widgets-wrapper';
import MainButton from '../../components/MainButton';
import { Control, Form, } from 'react-redux-form/immutable';
import SearchIcon from '../../image/search.png';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
// const { login, googleLogin } = authAction;
import AdPreview from '../../components/AdPreview';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';

import Header from "../../components/Headers/index";
import HeaderLogo from "../../components/Headers/Logo";
import HeaderAppInfo from "../../components/Headers/AppInfo/index";
import HeaderFillRow from "../../components/Headers/FillRow";
import SearchApp from "../../components/SearchAppBar/index";

const GravatarOption = createClass({
  propTypes: {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired,
  },
  handleMouseDown (event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  },
  handleMouseEnter (event) {
    this.props.onFocus(this.props.option, event);
  },
  handleMouseMove (event) {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  },
  render () {
    let gravatarStyle = {
      borderRadius: 3,
      display: 'inline-block',
      marginRight: 10,
      position: 'relative',
      top: -2,
      verticalAlign: 'middle',
      width: '40px',
      height: '40px'
    };
    let logoStyle = {
      width: '56px',
      height: '56px'
    };
    console.log( this.props.option)
    return (
      <div className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}>
          <div >
            <img
                style={gravatarStyle}
                src={this.props.option.options.artworkUrl60}
            />
        </div>
        {this.props.children}
      </div>
    );
  }
});


class Home extends Component {

  state = {
    updated: false,
    campaignList: null,
    redirectToReferrer: false,
    optionList : null,
  };


  async handleSignUpSubmit(signUpData ){
    console.log( 'singupdata: ' , signUpData,  process.env.REACT_APP_STAGE );
    if ( process.env.REACT_APP_STAGE === 'fake'){
      console.log( 'fakeLogin: '  );

      this.props.auth.fakeLogin();
    } else if (signUpData.password !== signUpData.confirmPassword){
      this.setState({signupResponse : {
        message: {
          error: "invalid_input",
          error_description: "Password and Confirm Password do not match."
        }
      }});
    } else {
      try {
        this.setState({signupResponse : null});
        const request = {
          email : signUpData.emailAddress,
          firstname: signUpData.firstName,
          lastname: signUpData.lastName,
          password: signUpData.password,
        };
        const signupResponse = await axios.post(`${API_URL}/user/create/`, request, {  } )
        this.setState({signupResponse});
        console.log( 'signupResponse',signupResponse)
        const loginResponse = await this.props.auth.passwordLogin(signUpData.emailAddress, signUpData.password);

      } catch(error) {
        const errorResponse = error.response.data.error;
        console.log( 'errorResponse',errorResponse);

        this.setState({signupResponse : {
          message: {
            error: errorResponse.code,
            error_description: errorResponse.message
          }
        }});
      }

    }

  }

  async handleSignInSubmit (signInData ){
    console.log( 'singindata: ' , signInData );
    // let result = this.props.auth.passwordLogin('dsfasdf', 'dasfaf');
    console.log( 'signin')
    if ( process.env.REACT_APP_STAGE === 'fake'){
      this.props.auth.fakeLogin();
    } else {
      try {
        this.setState({loginResponse : null});
        const loginResponse = await this.props.auth.passwordLogin(signInData.emailAddress, signInData.password);
        this.setState({loginResponse});
        console.log( 'loginResponse',loginResponse)
      } catch(error) {
        console.log( error)
      }

    }
   
  }

  componentDidUpdate(prevProps, prevState) {

    if ( !prevState.loginResponse && this.state.loginResponse){


      console.log( ' loginResponsechanged')
    }

  }

  handleGoogleAuth = e => {
    e.preventDefault();
    console.log( ' handleGoogleAuth')
    this.props.auth.googleLogin();
  }

  login() {
    console.log( 'login')
    this.props.auth.login();
  }

  onChange = (app) => {
		this.setState({
			value: app,
    });

    const { optionList, input } = this.state;
    if ( optionList && optionList.length > 1){
      this.props.appSelected(app.value , optionList[1].value);
    } else if ( optionList && optionList.length === 1){
      this.props.appSelected(app.value , app.value);
    } else {
      this.props.appSelected(app.value , null);    
    }
    this.props.searchTermUpdated(input);
  };

  getApps = (input) => {
    if (!input) {
      return Promise.resolve({ options: [] });
    }
    this.setState({ input })

    return axios.get(`https://itunes.apple.com/search`,
     { params: { term: input, country: 'us', entity: 'software'}})
      .then( (response) => {
        if(response.data != undefined){
          let itemData = response.data.results;
          let items = itemData.map( (item, i) =>  { 
            return { 
              key: i,
              label: item.trackCensoredName,
              id: i, 
              value: { 
                adamId: item.artistId,
                artworkUrl60: item.artworkUrl60,
                artworkUrl100: item.artworkUrl100,
                name: item.trackCensoredName,
                trackCensoredName: item.trackCensoredName,
                sellerName: item.sellerName,
                screenshotUrls: item.screenshotUrls,
              },
              options: item
            } 
          } )
          console.log( ' items ' , items );
          
          this.setState({ optionList: items })
          return { options: items };          
        }
      })
      .catch(error => {
        console.log( error.message)
      });  
  };
  

  render() {//https://itunes.apple.com/lookup?id=1155618808

    const { searchTerm, currentApp, secondApp} = this.props;    
    // const { isAuthenticated, login } = auth;
    const { rowStyle, colStyle } = basicStyle;
    
   
    return (
     <HomeWrapper>
      <Header>
        <div className="header-row">
          <HeaderLogo isClickable={true} history={this.props.history} />

          <HeaderFillRow className="hidden-md hidden-lg"/>
          {
            currentApp && (
              <HeaderAppInfo
                url={currentApp.artworkUrl100}
                appName={currentApp.trackCensoredName}
              >
                {currentApp.sellerName}
              </HeaderAppInfo>
            )
          }
          
          <HeaderFillRow className="hidden-xs"/>
          <SearchApp
            goTo={ (route) => this.props.history.push(`${route}`) }
            selectClassName="two-lines-result"
            value={this.state.value}
            onChange={this.onChange}
            backspaceRemoves={this.state.backspaceRemoves}
            placeholder="搜索你的应用名称或App ID"
          />
        </div>
      </Header>
      
      <div className="mainAppScreen">
       <div className="container">

            <Row style={rowStyle} gutter={0} justify="start">
                      
                    <Col md={12} sm={12} xs={24} style={colStyle}>
                        {/* Chart */}
                          <ContentHolder>
                            <div className="startWrapper">
                              <div className="firstLine">立即開始，</div>
                              <div className="secondLine">把你的应用展示在对的用户眼前吧！</div>

                              <IsoWidgetsWrapper>

                              <Tabs
                                defaultActiveKey="1"
                                renderTabBar={() =>
                                  <SwipeableInkTabBar
                                    pageSize={2}
                                    speed={5}
                                  />}
                                renderTabContent={()=><TabContent />}
                              >
                                <TabPane tab='注册' key="1">
                                <Form
                                    model="deep.auth0SignUp"
                                    onSubmit={(signUp) => this.handleSignUpSubmit(signUp)}
                                    >
                                    <br /><br />
                                    {
                                      false && (
                                        <MainButton>
                                          <div onClick={ (e) => this.handleGoogleAuth(e) }>
                                          { "SIGN UP WITH GOOGLE"}
                                          </div>
                                        </MainButton>
                                      )
                                    }

                                    <div className="inputWrapper">
                                      <label htmlFor="deep.auth0SignUp.emailAddress">邮箱</label>
                                      <div className="FormTextInput">
                                          <Control.text 
                                            model="deep.auth0SignUp.emailAddress" 
                                            id="deep.auth0SignUp.emailAddress"
                                            type="text" />
                                      </div>
                                    </div>

                                    <div className="inputWrapper">
                                      <label htmlFor="deep.auth0SignUp.firstName">昵称</label>
                                      <div className="FormTextInput">
                                          <Control.text 
                                            model="deep.auth0SignUp.firstName" 
                                            id="deep.auth0SignUp.firstName"
                                            type="text" />
                                      </div>
                                    </div>

                                    <div className="inputWrapper" hidden>
                                      <label htmlFor="deep.auth0SignUp.lastName">Last Name</label>
                                      <div className="FormTextInput">
                                          <Control.text 
                                            model="deep.auth0SignUp.lastName" 
                                            id="deep.auth0SignUp.lastName"
                                            type="text"
                                            value="" />
                                      </div>
                                    </div>

                                    <div className="inputWrapper">
                                      <label htmlFor="deep.auth0SignUp.password">密码</label>
                                      <div className="FormTextInput">
                                          <Control.text 
                                            model="deep.auth0SignUp.password" 
                                            id="deep.auth0SignUp.password"
                                            type="password" />
                                      </div>
                                    </div>

                                    <div className="inputWrapper">
                                      <label htmlFor="deep.auth0SignUp.confirmPassword">确认密码</label>
                                      <div className="FormTextInput">
                                          <Control.text 
                                            model="deep.auth0SignUp.confirmPassword" 
                                            id="deep.auth0SignUp.confirmPassword"
                                            type="password" />
                                      </div>
                                    </div>
                                    { this.state.signupResponse && this.state.signupResponse.message &&
                                      <div className="errorMsg">
                                        { this.state.signupResponse.message.error_description }
                                      </div>
                                    }
                                    <MainButton type="submit">
                                      { " 注册"}
                                    </MainButton>
                                    
                                    
                                </Form>
                                </TabPane>

                                <TabPane tab='登录' key="2">
                                <Form
                                    model="deep.auth0SignUp"
                                    onSubmit={(signUp) => this.handleSignInSubmit(signUp)}
                                    
                                >
                                  <br /><br />
                                  {
                                    false && (
                                      <MainButton >
                                        <div onClick={ this.handleGoogleAuth.bind(this) }>
                                        { "LOGIN WITH GOOGLE"}
                                        </div>
                                      </MainButton>
                                    )
                                  }

                                    <div className="inputWrapper">
                                      <label htmlFor="deep.auth0SignUp.emailAddress">邮箱</label>
                                      <div className="FormTextInput">
                                          <Control.text 
                                            model="deep.auth0SignUp.emailAddress" 
                                            id="deep.auth0SignUp.emailAddress"
                                            type="text" />
                                      </div>
                                    </div>

                                    <div className="inputWrapper">
                                      <label htmlFor="deep.auth0SignUp.password">密码</label>
                                      <div className="FormTextInput">
                                          <Control.text 
                                            model="deep.auth0SignUp.password" 
                                            id="deep.auth0SignUp.password"
                                            type="password" />
                                      </div>
                                    </div>
                                  
                                    <MainButton type="submit">
                                      { "登录" }
                                    </MainButton>
                                    
                                    { this.state.loginResponse && this.state.loginResponse.message &&
                                      <div className="errorMsg">
                                        { this.state.loginResponse.message.error_description }
                                      </div>
                                    }
                                </Form>
                                
                                
                                </TabPane>
                              </Tabs>
                               
                              
                              </IsoWidgetsWrapper>
                              
                            </div>

                          

                          </ContentHolder>
                    </Col>

                     {
                        currentApp && secondApp && (
                    <Col md={12} sm={12} xs={24} style={colStyle}>
                      <ContentHolder>
                        <AdPreview
                          currentApp={ currentApp }
                          secondApp={ secondApp }
                          searchTerm={ searchTerm }
                        />
                      </ContentHolder>
                    </Col>
                        )
                      }
              
                  
            </Row>
          </div>
        </div>
      </HomeWrapper> 
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { 
    setApp: (app) => dispatch(appSelected(app)),
    appSelected: bindActionCreators(appSelected, dispatch),
    searchTermUpdated:  bindActionCreators(searchTermUpdated, dispatch) ,

  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth0SignUp: state.get('deep').auth0SignUp,
    auth0SignIn: state.get('deep').auth0SignIn,
    isLoggedIn: false,//state.Auth.get('idToken') !== null ? true : false,
    currentApp: state.getIn( ['ItunesSearch', 'currentApp']),
    secondApp: state.getIn( ['ItunesSearch', 'secondApp']),
    searchTerm: state.getIn( ['ItunesSearch', 'searchTerm']),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);


// WEBPACK FOOTER //
// ./src/containers/Home/index.js